import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'playerShot',
  standalone: true
})
export class PlayerShotPipe implements PipeTransform {

  transform(value: number): string {
    switch (value) {
      case 1:
        return "LEFT"
        break;
     
      default:
        return "RIGHT"
        break;
     }
  }

}
